
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.433 0a.614.614 0 00-.573.649.614.614 0 00.65.57c6.095-.073 10.953 4.773 10.88 10.87h-.002a.61.61 0 001.22.02A11.921 11.921 0 0013.433 0V0zm-.048 3.963a.614.614 0 00-.572.648.614.614 0 00.649.572c3.907-.048 7.012 3.046 6.964 6.954h-.001a.61.61 0 001.22.02 8.07 8.07 0 00-8.26-8.193zM.553 5.49a.61.61 0 00-.553.61 18.86 18.86 0 005.545 13.356A18.864 18.864 0 0018.902 25l-.002-.001a.61.61 0 00.61-.61v-6.478a.61.61 0 00-.448-.59l-4.982-1.335a.612.612 0 00-.742.439l-.477 1.752c-1.272-.635-2.483-1.444-3.544-2.505-1.06-1.06-1.86-2.264-2.496-3.535l1.753-.476a.61.61 0 00.429-.743L7.669 5.935v.001a.61.61 0 00-.124-.228.605.605 0 00-.457-.22H5.183a.612.612 0 00-.618.61.61.61 0 00.618.61H6.62l1.048 3.935-1.915.524v-.002a.612.612 0 00-.39.83 14.765 14.765 0 007.64 7.64.608.608 0 00.829-.4l.524-1.906 3.935 1.048v5.373a17.625 17.625 0 01-11.89-5.163c-3.299-3.298-5.003-7.564-5.154-11.88h1.496a.61.61 0 100-1.22L.61 5.49a.458.458 0 00-.058 0zm12.794 1.829a.608.608 0 00-.572.648.614.614 0 00.649.571 3.567 3.567 0 013.649 3.65l-.002-.002a.612.612 0 101.22.01 4.818 4.818 0 00-4.887-4.878h-.056z"}})])
          )
        }
      }
    